import { ApiRequestError } from "../../api";

export function queueErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiRequestError) {
    if (error.status === 401) return "La sessione è scaduta. Accedi di nuovo e riprova.";
    if (error.status >= 500) return `${fallback}. Il servizio non risponde: riprova tra poco.`;
    return error.message;
  }
  if (error instanceof TypeError) return `${fallback}. Controlla la connessione e riprova.`;
  return error instanceof Error ? error.message : fallback;
}
